var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].href.startsWith('https://www.sotec.eu/')) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
  if (document.documentElement.lang === "en") {
    if (links[i].href.startsWith('https://www.sotec.eu/agb')) {
      links[i].href = 'https://www.sotec.eu/en/gtc';
    } else if (links[i].href.startsWith('https://www.sotec.eu/datenschutz')) {
      links[i].href = 'https://www.sotec.eu/en/privacy-policy';
    } else if (links[i].href.startsWith('https://www.sotec.eu/impressum')) {
      links[i].href = 'https://www.sotec.eu/en/imprint';
    }
  }
}

function changeBorderRadius() {
  // Get the parent element
  let parentElement = document.querySelector('.shopify-app-block');

  // Create a MutationObserver instance
  let observer = new MutationObserver((mutations) => {
    // Check if #app-embed and its shadowRoot are available
    let element = document.querySelector('#app-embed');
    if (element && element.shadowRoot) {
      // Create a new style element
      let style = document.createElement('style');
      style.textContent = `
        :host {
          --form-field-border-radius: 0;
          --button-border-radius: 0;
        }
      `;

      // Append the style element to the shadow root
      element.shadowRoot.appendChild(style);

      // Disconnect the observer when we're done
      observer.disconnect();
    }
  });

  // Start observing the parent element for child tree changes
  observer.observe(parentElement, { childList: true, subtree: true });
}

// Call the function when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', changeBorderRadius);